import './index.scss';
const EstrelabetCulturalCompetitionTerms = () => {
	return (
		<div className="estrelabetCulturalCompetitionTerms">
			<div className="content">
				<div className="title">
					TERMOS E CONDIÇÕES GERAIS DOS CONCURSOS CULTURAIS PROMOVIDOS PELA Mourgames
				</div>
				<div className="textItem">
					<h2>
						<b>1.INTRODUÇÃO:</b>
					</h2>

					<p>
						1.1. Este documento estabelece os Termos e Condições Gerais aplicáveis aos Concursos
						Culturais promovidos pela EstrelaBet, doravante referida como "Promotora". A
						participação em qualquer Concurso Cultural (daqui em diante denominado “Concurso
						Cultural” ou “Concurso”) implica o total entendimento e aceitação irrestrita destes
						termos por parte dos participantes.
					</p>

					<h2>
						<b>2. PARTICIPAÇÃO:</b>
					</h2>

					<p>
						2.1. A participação no Concurso Cultural promovido pela EstrelaBet é voluntária,
						gratuita, e não está condicionada à compra ou ao uso de qualquer produto, bem, direito
						ou serviço.
					</p>

					<p>
						2.2. Cada participante poderá inscrever-se uma única vez no Concurso Cultural, sendo que
						um participante só pode ser premiado uma vez durante o concurso.
					</p>

					<p>
						2.3. A Promotora se reserva o direito de desqualificar participantes que não cumpram com
						os requisitos de participação estabelecidos neste documento ou na legislação aplicável.
					</p>

					<h2>
						<b>3. ELEGIBILIDADE:</b>
					</h2>

					<p>
						3.1. Apenas respondentes qualificados pela EstrelaBet poderão participar do concurso
						cultural.
					</p>

					<p>3.2. Classificam-se como qualificados:</p>

					<ul>
						<li>
							<b>I)</b> pessoas físicas maiores de 18 (dezoito) anos;
						</li>
						<li>
							<b>II)</b> pessoas físicas residentes e domiciliadas em território nacional;
						</li>
					</ul>

					<p>
						3.3. Caberá aos vencedores de cada Concurso Cultural certificar-se da veracidade dos
						dados informados, como: telefone, endereço, CEP, CPF e e-mail.
					</p>

					<p>
						3.4. A participação é limitada a 1 (uma) participação por usuário no Concurso Cultural.
						Fica estabelecido que o participante só pode ser contemplado com um dos prêmios, uma
						única vez.
					</p>

					<h2>4. CRITÉRIOS DE DESCLASSIFICAÇÃO:</h2>

					<p>
						4.1. Estão impedidos de participar de qualquer Concurso Cultural os empregados,
						Colaboradores e/ou Prestadores de Serviços habituais da EstrelaBet e/ou da empresa que
						lhe presta serviços de intermediação e marketing no Brasil; e seus respectivos parentes
						até o segundo grau, em linha reta ou colateral.
					</p>

					<p>
						4.2. Fica estabelecido neste Regulamento que, caso o respondente não cumpra com os
						requisitos estabelecidos pela EstrelaBet será AUTOMATICAMENTE desclassificado e o prêmio
						destinado a outro participante, na forma destes Termos e Condições Gerais.
					</p>

					<h2>5. MODO DE FUNCIONAMENTO</h2>

					<p>
						5.1. O Concurso Cultural poderá ser realizado em diversas fases, com mecânicas
						específicas para cada etapa, determinadas a critério exclusivo da Promotora. Detalhes
						sobre as fases, prazos e critérios específicos serão divulgados por meio dos canais
						oficiais da EstrelaBet.
					</p>

					<h2>6. PREMIAÇÃO</h2>

					<p>
						6.1. Os prêmios serão especificados em cada Concurso Cultural promovido pela EstrelaBet
						e são pessoais e intransferíveis, sendo vedada a sua conversão em dinheiro.
					</p>

					<p>
						6.2. Os ganhadores serão selecionados com base em critérios previamente estabelecidos
						pela Promotora, e sua decisão será final e irrecorrível.
					</p>

					<p>
						6.3. O participante ganhador, ao receber as premiações do Concurso Cultural, concorda em
						aceitá-lo sem direito a futuras reivindicações à Promotora, bem como também concorda em
						isentar de toda e qualquer demanda ou ação legal consequente de sua participação no
						concurso ou recebimento e utilização de qualquer prêmio.
					</p>

					<p>
						6.4. A partir da verificação de um vencedor do Concurso Cultural, caso seja constatado
						que se trata de pessoa impedida de participar, o prêmio correspondente será destinado a
						outra participação imediatamente posterior àquela impugnada.
					</p>

					<p>
						6.5. Nos Concursos que tiverem como premiação a transferência de créditos na plataforma
						EstrelaBet, é elemento condicionante a existência de cadastro na plataforma. Caso o
						participante não possua cadastro e não tenha interesse em criá-lo, a premiação será
						transferida para outro participante, mediante os mesmos critérios do primeiro ganhador.
					</p>

					<p>
						6.6. A premiação será entregue/transferida aos vencedores em até 45 (quarenta e cinco)
						dias após o término do Concurso Cultural, após a validação dos ganhadores, sem qualquer
						ônus aos contemplados.
					</p>

					<h2>7. DIREITOS DE IMAGEM E DADOS PESSOAIS</h2>

					<p>
						7.1. Ao participar de qualquer Concurso Cultural, o participante autoriza o uso de sua
						imagem e nome pela Promotora, em quaisquer materiais de divulgação por até 1 (um) ano
						após o término do Concurso Cultural, sem que isso implique qualquer tipo de remuneração.
					</p>

					<p>
						7.2. Ao concorrer nas etapas dos Concursos Culturais promovidos pela EstrelaBet, o
						participante consente que a Promotora faça o tratamento de dados especiais nos termos
						descritos no presente Regulamento e conforme preconizado na Lei Geral de Proteção de
						Dados (LGPD), (Lei 13.709/2018), apresentados por ocasião da sua participação no
						Concurso.
					</p>

					<h2>8. DISPOSIÇÕES GERAIS</h2>

					<p>
						8.1. Quaisquer omissões ou controvérsias que surgirem sobre estes Termos e Condições
						Gerais serão dirimidas pela Promotora, por meio de critérios internos.
					</p>

					<p>
						8.3. Por se tratar de documento que regula uma ação cultural, a Promotora se reserva o
						direito de alterar, a seu critério, quaisquer programações e normas presentes nestes
						Termos e Condições Gerais, independentemente de qualquer autorização específica do
						participante.
					</p>

					<p>
						8.4. O resultado de cada Concurso Cultural será soberano e irrecorrível, inexistindo
						possibilidade de recurso para os participantes.
					</p>

					<p>
						8.5. A participação em qualquer Concurso Cultural promovido pela EstrelaBet é voluntária
						e gratuita, não estando condicionada, em hipótese alguma, à sorte, ao pagamento de preço
						e/ou à compra de produtos ou uso de qualquer bem, direito ou serviço pelo participante,
						de acordo com o artigo 3º, inciso II, da Lei n. 5.768/71 e com o artigo 30, do Decreto
						n. 70.951/72.
					</p>

					<p>
						8.6. Este documento poderá ser atualizado a qualquer momento pela Promotora, cabendo aos
						participantes verificar a versão mais recente antes de participar de qualquer Concurso
						Cultural.
					</p>

					<p>
						<b>DATA: 08/04/2024 </b>
					</p>

					<p>
						<b>VERSÃO: 1.0 </b>
					</p>
				</div>
			</div>
		</div>
	);
};
export default EstrelabetCulturalCompetitionTerms;
